import React from 'react';
import { DeltaInputContainer } from './input.styles';

interface Props {
  onIncrement?: () => void;
  onDecrement?: () => void;
  disabled?: boolean;
  readOnly?: boolean;
}

const IncrementControls = ({
  onIncrement,
  onDecrement,
  disabled,
  readOnly,
}: Props) => {
  const isDisabled = disabled || readOnly;

  return (
    <DeltaInputContainer>
      <button
        type='button'
        onClick={onDecrement}
        disabled={isDisabled}>
        –
      </button>

      <button
        type='button'
        onClick={onIncrement}
        disabled={isDisabled}>
        +
      </button>
    </DeltaInputContainer>
  );
};

export default IncrementControls;
